import { Client, FhbfMeasure } from '../../common/types/client';
import type { DecryptedItem } from '../../common/types/items';
import filter from '../../common/helpers/filter';

export const didMeasureTakePlace = (measure: FhbfMeasure): boolean =>
  measure.appointmentDidNotTakePlace === undefined || measure.appointmentDidNotTakePlace === false;

export const isMeasureCounseling = (measure: FhbfMeasure): boolean =>
  measure.type === 'telephoneConsultation' ||
  measure.type === 'personalConsultation' ||
  measure.type === 'outreachConsultation' ||
  measure.type === 'onlineConsultation';

export const isClientRelevantForStatistic = (client: DecryptedItem<Client>, year: string, advisor: string): boolean => {
  const measures = (client.payload.measures || []).filter((measure) => filter.isInYear(measure.date, year));
  const contactAttempts = (client.payload.contactAttempts || []).filter((contactAttempt) =>
    filter.isInYear(contactAttempt.date, year),
  );
  const isfirstContactInThisYear = filter.isInYear(client.payload.date, year);
  const hasMeasuresInThisYear = measures.length > 0;
  const hasContactAttemptsInThisYear = contactAttempts.length > 0;
  return (
    (advisor.length === 0 || client.payload.advisor === advisor) &&
    (isfirstContactInThisYear || hasMeasuresInThisYear || hasContactAttemptsInThisYear)
  );
};
